import { complianceChipsGroup } from "features/MappingEditor/utils";
import React from "react";
import { buildingStore } from "store/Building/BuildingStore";
import { conformityStore } from "../store/ConformityStore.ts";

export function useComplianceInfo() {
  React.useEffect(() => {
    (async () => {
      await conformityStore.fetchCertificationData();
      await conformityStore.fetchConformities();
    })();
  }, []);
  const getCurrentCertification = (certificationId?: string | null) => {
    const certification_id =
      certificationId ?? buildingStore.currentBuilding?.certification_id;
    return conformityStore.certificationOptions.find(
      (item) => item.id === certification_id
    );
  };

  const getConformitiesOfCertification = (certificationId?: string | null) => {
    return getCurrentCertification(certificationId)?.conformities ?? [];
  };

  const getCurrentConformity = () => {
    return getConformitiesOfCertification().find(
      (item) => item.id === buildingStore.currentBuilding?.conformity_id
    )?.name;
  };

  function getCertificationChipsGroup(
    availableItems: string[] | undefined | null
  ) {
    if (!availableItems) return null;

    const allCertifications = conformityStore.certificationOptions.filter(
      (item) => item.name !== "Keine"
    );

    return complianceChipsGroup(allCertifications, availableItems);
  }

  function getConformityChipsGroup(
    availableItems: string[] | undefined | null
  ) {
    if (!availableItems) return null;
    const filteredItems = conformityStore.conformityOptions.filter(
      (item) =>
        item.name !== "" && item.name != "Keine" && item.name != "Sonstige"
    );

    return complianceChipsGroup(filteredItems, availableItems);
  }

  return {
    getCurrentCertification,
    getConformitiesOfCertification,
    getCurrentConformity,
    getCertificationChipsGroup,
    getConformityChipsGroup,
  };
}
